import { render } from "./Panel.vue?vue&type=template&id=0f31d8c6"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nazikban/projects/credit-west-second/packages/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Panel.vue"]])

export default __exports__